<template>
    <div class="homeEn">
        11111
    </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex'
export default {
    data() {
        return {
        };
    },
    mounted() {
        this.switchLangq('en')
    },
    methods: {
        ...mapMutations('login', [
            'SWITCH_LANG',
        ]),

        switchLangq(value) {
            this.SWITCH_LANG(value)
            this.$i18n.locale = value
            this.$router.push('/home')
        },
    }
}
</script>

<style></style>
